// Silences console.log/debug/info in production builds
// Import this once at app bootstrap (e.g., in main.tsx)

if (import.meta.env.PROD) {
  ['log', 'debug', 'info'].forEach(method => {
    // @ts-ignore
    console[method] = () => {};
  });
} 